import React from 'react';
import styled from 'styled-components';
import {showAmount,FormatNumber} from '../../lib/util/CommonFunctions';
import {isMobileOnly} from 'react-device-detect';


const EsOrderDonePayinfoBlock = styled.div`
  tr:last-of-type td {border-bottom:1px solid #ccc;}
`;

const EsOrderDonePayinfo = ({ esOrderInfo }) => {

    // Return Mobile Phone Number Format
    const getPhoneNumber = (item) => {

        if (item === null || item === undefined || item.length === 0) {
            return ""
        } else if (item.length < 11) {
            return item;
        } else {
            return (item.substr(0, 3) + "-" + item.substr(3, 4) + "-" + item.substr(7, 4));
        }

    }

    // 견적 상품 금액
    const getEsTotalPrice = () => {
        let salePrice = esOrderInfo.data.orderinfo.od_prod_sale_price;
        let dscntPrice = esOrderInfo.data.orderinfo.od_es_sale_price;
        let totalPrice = salePrice - dscntPrice;
        return FormatNumber(totalPrice)
    }

    // 배송비 정보 반환
    const getDlvryPrice = () => {

        // 선불
        if (esOrderInfo.data.orderinfo.od_dlvry_type === '025201') {
            return (<p>선불(<span>{Number(esOrderInfo.data.orderinfo.od_dlvry_price.toFixed(1)).toLocaleString()}</span>원)</p>)
        } else if (esOrderInfo.data.orderinfo.od_dlvry_type === '025202') { // 착불
            return (<p>착불(<span>{Number(esOrderInfo.data.orderinfo.od_dlvry_price.toFixed(1)).toLocaleString()}</span>원)</p>)
        } else {
            return (<p>무료배송</p>)
        }
    }

    const customerInfo = (mobile) =>{
        const rowSpan=mobile?"1":"6";
        const borderBottom = mobile?"":"border_bottom";
        return(
          <React.Fragment>
              <td rowSpan={rowSpan} className={`gray ${borderBottom}`}>주문자 정보</td>
              <td rowSpan={rowSpan} className={`${borderBottom}`}>
                  <span>{esOrderInfo.data.orderinfo.od_nm}</span>
                  <br />
                  <span>{getPhoneNumber(esOrderInfo.data.orderinfo.od_mo_no)}</span>
                  <br />
                  <span>{esOrderInfo.data.orderinfo.email}</span>
              </td>
          </React.Fragment>
        )
    }

    return (<EsOrderDonePayinfoBlock>
          <div className="default-table margin_b-60">
              <h3 className="dt-title">결제 정보</h3>

              <table>
                  {!isMobileOnly&&
                  <colgroup>
                      <col width="180px;" />
                      <col width="410px;" />
                      <col width="180px;" />
                      <col width="410px;" />
                  </colgroup>
                  }
                  <tbody>
                  <tr>
                      <td className="gray">결제 금액</td>
                      <td>
                          {showAmount({amount:esOrderInfo.data.orderinfo.od_pay_price, weight:700, unit:"원", fontSize:"1em",unitWeight:"400"})}
                      </td>
                      {!isMobileOnly&&customerInfo(false)}
                  </tr>
                  {isMobileOnly&&<tr>{customerInfo(true)}</tr>}
                  <tr>
                      <td className="gray">견적 상품 금액</td>
                      <td><span>{getEsTotalPrice()}</span>원</td>
                  </tr>
                  <tr>
                      <td className="gray">배송비</td>
                      <td>
                          {getDlvryPrice()}
                          <p className="ess_text" style={{ display: esOrderInfo.data.orderinfo.od_dlvry_type === '025202' ? 'block' : 'none' }}>
                              ※ 예상 착불 배송비
                          </p>
                      </td>
                  </tr>
                  <tr>
                      <td className="gray">결제 방법</td>
                      <td>
                          {esOrderInfo.data.orderinfo.od_pay_type}
                      </td>
                  </tr>
                  {esOrderInfo.data.orderinfo.od_pay_type_code === "150402"&&
                  <React.Fragment>
                      <tr>
                          <td className="gray">입금 계좌번호</td>
                          <td>
                              <span>{esOrderInfo.data.orderinfo.od_vbank_name} {esOrderInfo.data.orderinfo.od_vbank_account}</span>
                          </td>
                      </tr>
                      <tr>
                          <td className="gray">입금 기한</td>
                          <td>
                              <span>{esOrderInfo.data.orderinfo.od_vbank_expiredate} (미입금 시 자동취소)</span>
                          </td>
                      </tr>
                  </React.Fragment>
                  }
                  </tbody>
              </table>
          </div>
      </EsOrderDonePayinfoBlock>
    );
};

export default EsOrderDonePayinfo;
